<template>
  <div class="bg-background-neutral-secondary space-y-4 rounded-2xl p-4">
    <div
      v-for="i in placeholderEntriesCount || DEFAULT_PLACEHOLDER_ENTRIES_COUNT"
      :key="i"
      class="shimmer h-[22px] w-full rounded-xl"
    ></div>
    <div class="shimmer h-6 w-full rounded-xl"></div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{ placeholderEntriesCount?: number }>();

  const DEFAULT_PLACEHOLDER_ENTRIES_COUNT = 3;
</script>
